import { render, staticRenderFns } from "./MemberSendMailDetail.vue?vue&type=template&id=06e6106f&scoped=true&"
import script from "./MemberSendMailDetail.vue?vue&type=script&lang=js&"
export * from "./MemberSendMailDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberSendMailDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MemberSendMailDetail.vue?vue&type=style&index=1&id=06e6106f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6106f",
  null
  
)

export default component.exports